(function Packages($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Packages/index', function onload()
		{
			$("a.info-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text($self.text());
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});

			$("a.package-fare-details").on('click', function showFareDetails(e) {
				var $self      = $(this),
				    package_id = $self.data("package-id"),
				    fare_type  = $self.data("type"),
				    body;

				Adzuki.Ajax.get('/Packages/fareDetails/' + package_id + '/' + fare_type)
				.then(function loadFareDetailsTable(response) {
					body = response;

					$modal.addClass('wide');
					$modal.find('.modal-title').text("Available " + fare_type + " categories");
					$modal.find('.modal-body').html(body);
					$modal.modal('show');
				});

				e.preventDefault();
			});


			$("#package-travel_start_date").on('dp.change', function handleChange(event) {
				if (event.date) {
					$('#package-travel_end_date')
						.data('DateTimePicker').date(event.date.add(30, 'days'));
				}
			});
		});

		Adzuki.onload('/Packages/view', function onload()
		{
			$("a.in  -link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text($self.text());
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});

			$('a.package-print').on('click', function printPackage(e) {
				e.preventDefault();
window.print();
				// window.open(Adzuki.base_uri + '/Packages/printPackage/' + $(this).data("id"));
			});
		});

		// We really only want this for tour and package components
		Adzuki.onload('/Reservations/editTravelComponentDetails', function onload()
		{
			var type = null;

			if ($('#reservationtourcomponentdetails-tour_company_id').length > 0) {
				type = 'tour';
			}
			if ($('#reservationpackagecomponentdetails-supplier_vendor_id').length > 0) {
				type = 'package';
			}

			if (type !== null) {
				initVendorChange(type);
			}
		});


		function initVendorChange(travel_type)
		{
			// onchange of tour company, need to toggle the visibility of queue triggered emails radio buttons
			$('.tour-company').on('change', function vendorChange(e) {
				var vendor_id  = $(this).val(),
				    $div       = $('#toggle-triggered-emails'),
				    $yes_label = $div.find('.btn.yes'),
				    $yes_radio = $yes_label.find(':radio'),
				    $no_label  = $div.find('.btn.no'),
				    $no_radio  = $no_label.find(':radio'),
				    url        = '';

				if (travel_type === 'tour') {
					url = '/TourCompanies/allowTriggeredEmailsByTourCompanyId/';
				} else {
					url = '/TourCompanies/allowTriggeredEmailsByVendorId/';
				}

				url += vendor_id;

				Adzuki.Ajax.get(url).then(function success(response) {
					if (response > 0) {
						$div.removeClass('hidden');
						$yes_label.addClass('active');
						$no_label.removeClass('active');
						$yes_radio.prop('checked', true);
						$no_radio.prop('checked', false);

					} else {
						$div.addClass('hidden');
						$yes_label.removeClass('active');
						$no_label.addClass('active');
						$yes_radio.prop('checked', false);
						$no_radio.prop('checked', true);
					}
				});
			});
		}
	});
}(jQuery, window.Adzuki || {}));
